import { useQuery } from '@apollo/client';
import { gql } from '@apollo/client/core';

const GET_CARD_DETAILS = gql`
  query currentConfig {
    current {
      config {
        seller {
          contact {
            formalName
            phone
            email
          }
          profile {
            title
            about
            instagramUrl
            facebookUrl
            tiktokUrl
            themeName
            fontFamily
            expertise
            galleryVideoLinks
            avatar {
              url
              mediumUrl
            }
            galleryImages {
              url
            }
          }
        }

        storefront {
          general {
            name
            shopUrl
            primaryColorHex
            secondaryColorHex
            logoImage {
              url
            }
            longLogoImage {
              url
            }
          }
        }
      }
    }
  }
`;

export const useGetCardDetails = () => {
  const { loading, error, data, refetch } = useQuery(GET_CARD_DETAILS, {
    context: { clientName: 'shop-api' },
    fetchPolicy: 'network-only',
  });

  return { loading, error, data, refetch };
};
